import { render, staticRenderFns } from "./PersonnelRules.vue?vue&type=template&id=baed1b5e&scoped=true&"
import script from "./PersonnelRules.vue?vue&type=script&lang=js&"
export * from "./PersonnelRules.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelRules.vue?vue&type=style&index=0&id=baed1b5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed1b5e",
  null
  
)

export default component.exports